import { $api } from '@shared/api';
import { routes } from '@shared/api/routes';

export const getPositionList = ({ signal }: { signal: AbortSignal }) =>
    $api.get(routes.getEstimateSupplyRequestPositionList(), { signal });

export interface ICreateSupplyRequestPosition {
    guid: string;
    amount: number;
    required_delivery_date: string;
    comment?: string;
}

export interface ICreateSupplyRequestExtraPosition {
    name: string;
    unit: string;
    amount: number;
    required_delivery_date: string;
    comment?: string;
}

export interface ICreateSupplyRequestPayload {
    positions?: ICreateSupplyRequestPosition[];
    extra_positions?: ICreateSupplyRequestExtraPosition[];
}

export const createSupplyRequest = (payload: ICreateSupplyRequestPayload) =>
    $api.post(routes.createEstimateSupplyRequest(), payload);
